<template>
<div class="clearfix">
    <div class="container">
        <el-card class="card">
            <span class="title">设置密码</span>
            <div class="item-column">
                <span class="tips">由于您初次登录，请设置密码</span>
            </div>
            <div class="item-column">
                <span class="span-hint" v-show="!password_status">{{password_hint}}</span>
                <el-input placeholder="字母和数字组合，最少6位" size="medium" v-model="password" @blur='passwordOnBlur' maxlength=20 @keyup.enter.native="setPasswordConfirm" show-password></el-input>
            </div>
            <div class="item-column">
                <span class="span-hint" v-show="!repassword_status">{{repassword_hint}}</span>
                <el-input placeholder="请确认密码" size="medium" v-model="repassword" @blur='repasswordOnBlur' @keyup.enter.native="setPasswordConfirm" maxlength=20 show-password></el-input>
            </div>
            <div class="item-column">
                <el-button class="btn-confirm" size="medium" type="primary" @click="setPasswordConfirm">确 定</el-button>
            </div>
        </el-card>
    </div>
</div>
</template>
<script>
export default {
    data () {
        return {
            password_hint:'请输入密码',
            password_status:true,
            password:'',
            repassword_hint:'请输入确认密码',
            repassword_status:true,
            repassword:''
        }
    },
    methods:{
        passwordOnBlur(){
            if(this.password.length == 0){
                this.password_status = false
                this.password_hint='请输入密码'
            }else if(!/^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$/.test(this.password)){
                this.password_status = false
                this.password_hint = '密码须为字母和数字组合，最少6位'
            }else{
                this.password_status = true
            }
        },
        repasswordOnBlur(){
            if(this.repassword.length == 0){
                this.repassword_status = false
                this.repassword_hint='请输入确认密码'
            }else if(!/^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$/.test(this.repassword)){
                this.repassword_status = false
                this.repassword_hint = '密码须为字母和数字组合，最少6位'
            }else{
                this.repassword_status = true
            }
        },
        setPasswordConfirm(){
            if(this.password.length == 0){
                this.$message({
                    message: '请输入密码',
                    type: 'fail'
                });
                return
            }
            if(!/^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$/.test(this.password)){
                this.$message({
                    message: '密码须为字母和数字组合，最少6位',
                    type: 'fail'
                });
                return
            }
            if(this.repassword.length == 0){
                this.$message({
                    message: '请输入确认密码',
                    type: 'fail'
                });
                return
            }
            if(!/^(?=.*[a-zA-Z])(?=.*[0-9]).{6,}$/.test(this.repassword)){
                this.$message({
                    message: '密码须为字母和数字组合，最少6位',
                    type: 'fail'
                });
                return
            }
            if(this.repassword !== this.password){
                this.$message({
                    message: '两次输入密码不一致',
                    type: 'fail'
                });
                this.repassword = ''
                return
            }
            var signupParams = {
                password:this.password,
            }
            this.loading = true
            this.wjtHttp.post(this,'/api/setPwd',signupParams,false,(res)=>{
                this.loading = false
                var data = res.data
                if(data.code == 200){
                    this.$message({
                        message: '密码设置成功',
                        type: 'success'
                    });
                    if(!this.utils.isEmptyStr(this.fromPath) && this.fromPath != '/'){
                        this.$router.go(-1)
                    }else{
                        this.$router.replace('/')
                    }
                }else{
                    this.$message({
                        message:(data.msg&&data.msg.length > 0)?data.msg:'服务异常，请联系管理员',
                        type:'error'
                    })
                }
            },(err)=>{
                this.loading = false
            })
        }

    },
    watch:{
        verify_second:function(val){
            if(val){
                this.btn_verify = this.verify_second+'后重发'
            }else{
                this.btn_verify = '获取验证码'
            }
        },
        login_type:function(val){
            if(val == 'verify'){
                this.login_change_text = '密码登录'
            }else{
                this.login_change_text = '忘记密码？'
            }
        }
    },
    beforeRouteEnter(to,from,next){
        next(vm =>{
            vm.fromPath = from.path
        })
    }
}
</script>
<style scoped>
    .container{
        margin: 0 auto;
        position: relative;
    }
    .clearfix:after, .clearfix:before {
        content: " ";
        display: table;
    }
    .card{
        margin: 30px auto;
        padding: 3% 3%;
        background-color: #fff;
        max-width: 375px;
        width: 100%;
    }
    .title{
        text-align: center;
        font-size: 30px;
        color: #333333;
        position: relative;
        bottom: 20px;
    }
    .span-hint{
        font-size: 14px;
        color: #ff5a05;
        padding: 10px 0;
        text-align: left;
    }
    .tips{
        font-size: 16px;
        color: #999999;
        text-align: center;
    }
    .item-column{
        display: flex;
        flex-direction: column;
        margin-bottom: 32px;
    }
    .item-row{
        display: flex;
        flex-direction: row;
    }
    .btn-verify{
        margin-left: 18px;
    }
    .span-password-login{
        width: 90px;
        height: 100%;
        font-size: 16px;
        color: #FE9400;
        text-align: right;
    }
    .span-change-verify{
        font-size: 16px;
        color: #FE9400;
        text-align: center;
        padding: 8px 0;
    }
    .btn-confirm{
        width: 100%;
        height: 45px;
        margin-top: 62px;
    }
    .span-third-login{
        font-size: 16px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        color: #333333;
    }
    .img-wx{
        width: 36px;
        height: 36px;
        margin-top: 20px;
        position: relative;
        margin-left: calc(50% - 16px);
    }
    .span-signup-text{
        width: calc(100% - 90px);
        font-size: 16px;
        text-align: left;
        color: #333333;
        display: flex;
        align-items: center;
    }
    .span-signup-text>span{
        font-size: 16px;
        color: #FE9400;
    }
</style>
